import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { HeaderSort } from './models/header-sort.model';
import { SortState } from './models/enums/sort-state.enum';

@Injectable()
export class HeaderSortService {
    private readonly sort$: ReplaySubject<HeaderSort>;
    private headerSort: HeaderSort;

    constructor(
    ) {
        this.sort$ = new ReplaySubject<HeaderSort>(1);
    }

    public getHeaderSort(): Observable<HeaderSort> {
        return this.sort$.asObservable();
    }

    public setHeaderSort(
        key: string,
        sortAscending: boolean,
        secondaryKey?: string,
        secondarySortAscending?: boolean,
        initialState?: SortState
    ): void {
        this.headerSort = new HeaderSort(key, sortAscending, secondaryKey, secondarySortAscending, initialState);
        this.sort$.next(this.headerSort);
    }

    public resort(defaultSortConfig?: HeaderSort): void {
        if (this.headerSort) {
            this.sort$.next(this.headerSort);
        } else {
            if (defaultSortConfig) {
                this.headerSort = defaultSortConfig;
                this.sort$.next(defaultSortConfig);
            }
        }
    }
}
